import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addAfterCredentialsLoginHook } from '../store/actions';

export const useAddCredentialsLoginHook = () => {
    const dispatch = useDispatch();

    return useCallback((callback) => {
        dispatch(addAfterCredentialsLoginHook(callback));
    }, [dispatch]);
};
